const useFlagVariation = (flagName) => {
  return {
    isError: false,
    isLoading: false,
    variation: Signalman.featureFlag(flagName)
  };
};

export default useFlagVariation;
